export default __webpack_public_path__ + "locales/el-GR/About.json?hash=207d374e381bab2db03b14a622d6afe0";